/**
* Import Gallery
*/
import InitMap from './components/map.js';

/**
* Init - initalises all project classes
*/
class Init{

	constructor(){
		new InitMap()
	}

}

new Init()
